
  import { Component, Prop, Vue } from 'vue-property-decorator'

  import ApplyPromoCodes from '@/checkout/components/ApplyPromoCodes.vue'
  import ExpiryTimer from '@/components/cart/ExpiryTimer.vue'
  import Price from '@/components/elements/Price.vue'
  import { cartExpiresIn } from '@/state/Cart'
  import type { CartItem } from '@/store/CartItem'

  import PayButton from './PayButton.vue'

  @Component({
    components: {
      ApplyPromoCodes,
      ExpiryTimer,
      PayButton,
      Price,
    },
  })
  export default class DemoCartWidget extends Vue {
    @Prop({ default: () => [] })
    cartItems!: CartItem[]

    @Prop({ default: true })
    showTotals!: boolean

    @Prop({ default: true })
    isModifiable!: boolean

    // Bundle expansion state - start with bundles expanded
    expandedBundles: Record<string, boolean> = {}

    get empty(): boolean {
      return this.items.length === 0
    }

    get items(): CartItem[] {
      return this.cartItems || []
    }

    get hasUpsells(): boolean {
      return this.items.some((item) => !item.isAnchor)
    }

    get promoCodeApplyEnabled(): boolean {
      return this.isModifiable && this.totalPrice > 0
    }

    get totalPrice(): number {
      return this.items.reduce((total, item) => {
        return total + item.types.reduce((itemTotal, type) => itemTotal + type.totalPrice, 0)
      }, 0)
    }

    // Dummy timer for demo purposes - always shows 12 minutes remaining
    get expiresIn() {
      return cartExpiresIn()
    }

    mounted() {
      // Initialize all bundles as expanded
      this.items.forEach((item) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((item as any).isBundle) {
          this.$set(this.expandedBundles, item.id, true)
        }
      })
    }

    toggleBundle(bundleId: string): void {
      this.$set(this.expandedBundles, bundleId, !this.expandedBundles[bundleId])
    }

    handleRemoveItem(item: CartItem, index: number): void {
      this.$emit('remove-item', item, index)
    }
  }
